import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { theme } from './theme';
import { GlobalStyles } from './components/styled/GlobalStyles';
import { store } from './store/configureStore';
import { hydrateMe } from './store/reducers/authReducer';

if (typeof window !== 'undefined') {
  store.dispatch(hydrateMe());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// WebVitals kept for later; not needed for MVP.
